import config from 'admin/config/main'
import createApiReducer from 'redux/utils/createApiDuck'
import { APIState } from 'types'

const moduleName = `${config.appName  }/featureToggle`

export default createApiReducer(moduleName)

export type FeatureToggleAdmin ={
  exportInvoicePDF: string
  exportInvoiceSpecificationExcel: string
  invoiceRecipientAdmins: string
}

export interface FeatureToggleState extends APIState {
  data: FeatureToggleAdmin
}
